import {createContext, useState} from "react";

const UserContext = createContext({});

const UserProvider = (props) => {
  const [user, setUser] = useState(
    {
      uuid: null,
      nome: null,
      avatar: null,
      nivel: null,
      funcao: null
    }
  );

  const value = {user, setUser};

  return(
    <UserContext.Provider value={value}>
      {props.children}
    </UserContext.Provider>
  );
}

export {UserContext, UserProvider}